import React from "react";
import { Footer } from "./Footer";
import { Header } from "./Header";
import { MobileConversionBar } from "./MobileConversionBar";
type SiteLayoutProps = {
  children: React.ReactNode;
};
export function SiteLayout({
  children
}: SiteLayoutProps) {
  return <div id="top" className="min-h-screen w-full overflow-x-hidden bg-white pb-16 text-ink md:pb-0" data-id="element-277" data-mp="34xr28344fh4a">
      <a href="#main-content" className="fixed left-4 top-3 z-[60] -translate-y-20 rounded-md bg-ink px-4 py-3 text-sm font-bold text-white transition-transform duration-150 ease-out focus:translate-y-0" data-id="element-278" data-mp="39s4rdns6ws0i">
        Skip to main content
      </a>
      <Header data-id="element-279" data-mp="3nmxcd1qun0eh" />
      <main id="main-content" data-id="element-280" data-mp="3nn76n1ixftpz">{children}</main>
      <Footer data-id="element-281" data-mp="3skz4ec696a23" />
      <MobileConversionBar data-id="element-282" data-mp="3slidr4hu7q4i" />
    </div>;
}